namespace TabAurous.Common {
    export interface AllFiltersForm {
        Suppliers: Serenity.LookupEditor;
        Customers: Serenity.ServiceLookupEditor;
        VoucherTypeId: _Ext.EmptyLookupEditor;
        VoucherNo: _Ext.EmptyLookupEditor;
        BagNo: _Ext.EmptyLookupEditor;
        CategoryId: _Ext.EmptyLookupEditor;
        SubCategoryId: _Ext.EmptyLookupEditor;
    }

    export class AllFiltersForm extends Serenity.PrefixedContext {
        static formKey = 'Common.AllFilters';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AllFiltersForm.init)  {
                AllFiltersForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = _Ext.EmptyLookupEditor;

                Q.initFormType(AllFiltersForm, [
                    'Suppliers', w0,
                    'Customers', w1,
                    'VoucherTypeId', w2,
                    'VoucherNo', w2,
                    'BagNo', w2,
                    'CategoryId', w2,
                    'SubCategoryId', w2
                ]);
            }
        }
    }
}
